if (!customElements.get('cart-nosto-recommendations')) {
  /**
   * Defers the cart drawer's <nosto-section-campaign> until the recommendations are visible,
   * i.e. the drawer is open. The campaign is kept inside a <template> so it is not upgraded
   * (and does not request recommendations) until it is injected.
   */
  class CartNostoRecommendations extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      if (!this.template) return;

      this.observer = new IntersectionObserver(this.onIntersect.bind(this));
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    onIntersect(entries) {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      this.observer.disconnect();
      this.template.replaceWith(this.template.content.cloneNode(true));
    }
  }
  customElements.define('cart-nosto-recommendations', CartNostoRecommendations);
}
